import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Lock, CheckCircle2, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const tk = params.get("token");
    if (tk) setToken(tk);
  }, [params]);

  const submit = async (e) => {
    e?.preventDefault();
    if (pwd.length < 6) { setError("Password must be at least 6 characters."); return; }
    if (pwd !== confirm) { setError("Passwords don't match."); return; }
    setError(""); setLoading(true);
    try {
      await api("/auth/reset-password", { method: "POST", body: { token, new_password: pwd }, auth: false });
      setDone(true);
    } catch (err) {
      setError(err.message || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-md mx-auto px-6 py-10">
        <Lock size={36} color="#D62828" />
        <h1 className="font-display text-3xl font-black mt-4">Choose a new password</h1>

        {done ? (
          <div data-testid="reset-success" className="mt-8 p-6 rounded-2xl text-center status-placed">
            <CheckCircle2 size={28} className="mx-auto" />
            <h3 className="font-display text-xl font-black mt-2">Password updated!</h3>
            <button data-testid="go-login-btn" onClick={() => navigate("/login")} className="btn-primary w-full mt-5 !py-3.5">Sign In</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5">
            {!params.get("token") && (
              <div>
                <label className="label-up">Reset token (paste from email)</label>
                <input data-testid="reset-token-input" className="input-field" value={token} onChange={(e) => setToken(e.target.value)} />
              </div>
            )}
            <div>
              <label className="label-up">New password</label>
              <input data-testid="reset-pwd-input" className="input-field" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} />
            </div>
            <div>
              <label className="label-up">Confirm password</label>
              <input data-testid="reset-confirm-input" className="input-field" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </div>
            {error && <div data-testid="reset-error" className="text-sm font-bold" style={{ color: "#C62828" }}>{error}</div>}
            <button data-testid="reset-submit-btn" disabled={loading || !token} className="btn-primary w-full !py-3.5">
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Update Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
